import { ColDef, ITextFilterParams } from "ag-grid-community";

export const textFilterParams: ITextFilterParams = {
	debounceMs: 200,
	maxNumConditions: 10,
	filterOptions: [
		"contains",
		"notContains",
		{
			displayKey: "simpleSearch",
			displayName: "Simpel zoeken",
			predicate: ([filterValue], cellValue) => cellValue == null || cellValue < filterValue,
		},
		{
			displayKey: "advancedSearch",
			displayName: "Geavanceerd zoeken",
			predicate: ([filterValue], cellValue) => cellValue == null || cellValue < filterValue,
		},
		"equals",
		"notEqual",
		"startsWith",
		"endsWith",
		"blank",
		"notBlank",
	],
};

/**
 * Text column type for the ag-grid.
 */
export const TextColumn: ColDef = {
	filter: "agTextColumnFilter",
	floatingFilter: true,
	filterParams: textFilterParams,
	// Enables the column to be edited.
	// editable: true,
	// cellEditor: "agTextCellEditor",
	// cellEditorParams: {
	//   maxLength: 20
	// }
};
